module.exports = __webpack_public_path__ + "img/chevron.46b06ca9.svg";